import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

// Importing official team images
import leader1 from "../../Assets/LeadershipSection/leader1.jpg";
import leader2 from "../../Assets/LeadershipSection/leader2.jpg";
import leader3 from "../../Assets/LeadershipSection/leader3.jpg";
import leader4 from "../../Assets/LeadershipSection/leader4.jpg";

const team = [
  {
    name: "Suresh",
    role: "Founder & CEO",
    image: leader1,
    objectPosition: "center 15%",
  },
  {
    name: "Priyanka",
    role: "Chief Architect",
    image: leader2,
    objectPosition: "center center",
  },
  {
    name: "Vishnu",
    role: "Director of Real Estate",
    image: leader3,
    objectPosition: "center 15%",
  },
  {
    name: "Sofia",
    role: "Head of Interior Design",
    image: leader4,
    objectPosition: "center center",
  },
];

const LeaderShipTeamSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FCF9F8",
        // Specs: 128px padding top and bottom
        py: { xs: "80px", md: "128px" },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1536px",
          width: { xs: "100%", lg: "1280px" },
          px: { xs: "24px", md: "48px" },
        }}
      >
        {/* Header Block */}
        <Box
          sx={{
            textAlign: "center",
            mb: { xs: "64px", md: "80px" },
            width: "100%",
            maxWidth: "1184px",
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: 800,
                fontSize: { xs: "36px", md: "48px" },
                lineHeight: "48px",
                letterSpacing: "-1.2px",
                color: "#1C1B1B",
                mb: "16px",
              }}
            >
              The Visionaries
            </Typography>
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 300,
                fontSize: { xs: "16px", md: "18px" },
                lineHeight: "28px",
                color: "#5A413A",
                maxWidth: "672px",
                mx: "auto",
                textAlign: "center",
              }}
            >
              Leading with passion, precision, and a collective experience of
              over a century in global real estate.
            </Typography>
          </motion.div>
        </Box>

        {/* Team Grid - Reverted to Square Spacing */}
        <Grid container spacing={4}>
          {team.map((member, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <Box sx={{ textAlign: "center" }}>
                  {/* Portrait Box - Square Aspect Ratio */}
                  <Box
                    sx={{
                      width: "100%",
                      aspectRatio: "1/1",
                      borderRadius: "8px",
                      overflow: "hidden",
                      mb: "24px",
                      boxShadow: "0px 15px 40px rgba(0,0,0,0.08)",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <Box
                      component="img"
                      src={member.image}
                      alt={member.name}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition:
                          member.objectPosition || "center center",
                        filter: "grayscale(30%)",
                        transition: "all 0.5s ease",
                        "&:hover": {
                          filter: "grayscale(0%)",
                          transform: "scale(1.05)",
                        },
                      }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Manrope, sans-serif",
                      fontWeight: 700,
                      fontSize: "20px",
                      color: "#1C1B1B",
                      mb: "4px",
                    }}
                  >
                    {member.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 600,
                      fontSize: "12px",
                      color: "#FF5722",
                      textTransform: "uppercase",
                      letterSpacing: "1.5px",
                    }}
                  >
                    {member.role}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default LeaderShipTeamSection;
